// schema.js
import { pgTable, serial, text, timestamp } from "drizzle-orm/pg-core";

export const tags = pgTable("gamma_query_cache_tags", {
  id: serial("id").primaryKey(),
  queryId: text("query_id").notNull(),
  cacheTag: text("cache_tag").notNull(),
  createdAt: timestamp("created_at").notNull().defaultNow(),
});
